import { ScreenFieldService } from "../_services/api/reports/screen-field.service";
import appConfig from "../app-config";

export const globalFields = {
  namespaced: true,
  state: {
    // this state is replaced by the api/ScreenField call
    globalFields: [],
  },
  actions: {
    async getGlobalFields({ commit }) {

      var globalFieldItems = undefined;

      if (appConfig.VUE_APP_COOKIE_NAME != 'DEV') {
        globalFieldItems = JSON.parse(
          localStorage.getItem(`globalFields_${appConfig.VUE_APP_COOKIE_NAME}`)
        )
      }

      if (!globalFieldItems)
        return ScreenFieldService.getGlobalFields().then((res) => {
          if (res.data.value)
            // eslint-disable-next-line no-console
            console.log("================= getGlobalFields", res.data.value);
          commit(
            "setGlobalFields",
            res.data.value.map((x) => {
              // eslint-disable-next-line no-console
              // console.log("xxxx", x);
              let definition;
              try {
                definition = JSON.parse(x.Definition);
                definition.fieldName = x.Code;
              } catch (e) {
                // eslint-disable-next-line no-console
                console.log("======= ERROR", x);
              }
              return definition;
            })
          );
        });
      else commit("setGlobalFields", globalFieldItems);
    },
    // eslint-disable-next-line no-unused-vars
    setInitialGlobalFields({ commit, dispatch }) {
      dispatch("getGlobalFields");
    },
  },
  mutations: {
    setGlobalFields(state, globalFields) {
      state.globalFields = globalFields;
      localStorage.setItem(
        `globalFields_${appConfig.VUE_APP_COOKIE_NAME}`,
        JSON.stringify(globalFields)
      );
    },
  },
  getters: {
    getGlobalField: (state) => (fieldName) => {
      if (state.globalFields.length == 0) {
        state.globalFields = JSON.parse(
          localStorage.getItem(`globalFields_${appConfig.VUE_APP_COOKIE_NAME}`)
        );
      }
      return state.globalFields.find((i) => {
        if (i) return i.fieldName == fieldName;
      });
    },
  },
};
